import React from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Unstable_Grid2";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Button from "@mui/material/Button";
import styled from "styled-components";
// import Avatar from "@mui/material/Avatar";

const AccountsMenu = () => {
  const userProfile = useSelector(
    (state) => state.userDetails?.userProfile || {}
  );
  const { fullName = "" } = userProfile;
  const uppercaseFullName = fullName?.toUpperCase() || "";

  const handleLogout = () => {
    localStorage.removeItem("userToken");
    if (window) {
      window.location.href = "/";
    }
  };

  const ListItems = styled.div`
  
  display:flex;
  flex-direction:column;
  justify-content:flex-start;
  align-items:center;
  background-color:#f2f2f2;
  min-height:331px;
  padding-top:1rem;

  
  `
  const ListItem = styled.div`
  
  display:flex;
  flex-direction:row;
  justify-content:flex-start;
  align-items:center;
  padding:.9rem 1rem;
  width:91%;
  font-size:14px;
  border-bottom:1px solid rgba(145, 145, 145, 0.17);
  cursor:pointer;

  img {
  width:26px;
  margin-right:.4rem;
  }
  
  `

  const Container = styled.div`
  
  
  @media(max-width:851px){
display:none;

}
  
  `
const MiniMenu = styled.div`
display:none;
@media(max-width:851px){
display:flex;
justify-content:space-between;
align-items:center;
padding:.5rem .7rem;
background-color:#f3f3f3;
width:97vw;
border-radius:55px;

}
`
const MenuItem = styled.div`
width:23%;
background-color: #fff;
color:#333;
display:flex;
justify-content:center;
align-items:center;
border-radius:5px;
`
const mymenu = [{text:'Profile Info'},{text:'Address'},{text:'Wishlist'},{text:'Wallet'}]

  const navigate = useNavigate()

  return (
    <React.Fragment>
      <MiniMenu>
        {mymenu.map((item,index)=>
        <MenuItem key={index} onClick={()=>{navigate(`?AM=${item.text.toLowerCase()}`)}}>
          {item.text}
        </MenuItem>
        )}
      </MiniMenu>
      <Container >
        <Box sx={{ flexGrow: 1, textAlign: "center" }}>
          <Paper variant="none" elevation={3} style={{backgroundColor:'#f3f3f3',padding:'.5rem 2.2rem',borderRadius:5}} square>
           <div style={{display:'flex',justifyContent:'flex-start',fontSize:14}}> 
           Hello, {uppercaseFullName}
           </div>
          </Paper>
        </Box>
        <Box sx={{ flexGrow: 1 }}>
          <ListItems>
            <ListItem onClick={()=>{navigate('?AM=profile')}}>
             <img src="/temp_images/user.svg"  width={21}/>
           <div>Profile Info</div>
            </ListItem>
            <ListItem onClick={()=>{navigate('?AM=address')}}>
           <img src="/temp_images/user.svg"  width={21}/>
  <div>Address</div>
            </ListItem  >
            <ListItem onClick={()=>{navigate('?AM=wishlist')}}>
           <img src="/temp_images/user.svg"  width={21}/>
  <div>Wishlist</div>
            </ListItem>

          {/*        <ListItem onClick={()=>{navigate('?AM=wallet')}}>
           <img src="/temp_images/user.svg"  width={21}/>
  <div>Wallet</div>
            </ListItem> */}
     

          </ListItems>
        
        </Box>
      </Container>
    </React.Fragment>
  );
};

export default AccountsMenu;





/* 
<Grid>
<Grid sx={{ p: 2 }}>
  <Button variant="text" size="large" onClick={handleLogout}>
    Logout
  </Button>
</Grid>
</Grid> */







{/* <Grid>
<Typography variant="h6" fontWeight={500}>
  ACCOUNT SETTINGS
</Typography>
</Grid>
<Grid>
<Link to="?AM=profile" className="route-link-black">
  <ListItemButton>
    <ListItemText primary="Profile Information" />
  </ListItemButton>
</Link>
</Grid>
<Grid>
<Link to="?AM=address" className="route-link-black">
  <ListItemButton>
    <ListItemText primary="Manage Addressess" />
  </ListItemButton>
</Link>
</Grid>
<Grid>
<Link to="?AM=wishlist" className="route-link-black">
  <ListItemButton>
    <ListItemText primary="My Wishlist" />
  </ListItemButton>
</Link>
</Grid> */}

 {/* <Grid sx={{ pt: 2 }}>
                <Grid>
                  <Typography variant="h6" fontWeight={500}>
                    PAYMENTS
                  </Typography>
                </Grid>
                <Grid>
                  <Link to="?AM=carddetails" style={{ textDecoration: "none" }}>
                    <ListItemButton>
                      <ListItemText primary="Saved Cards" />
                    </ListItemButton>
                  </Link>
                </Grid>
              </Grid> */}